<template>
    <div class="backdrop" @click.self="onClose">
        <div class="job-runner-viewer-modal">            
            <div style="height: 50px; display:flex; flex-direction: columns;justify-content:space-between;background-color: var(--con-main-theme-card-header-color-2);">
                <div class="report-title" style="margin: auto 10px">Jobs Viewer</div>                
                <div style="margin: auto 0px; font-size: 14px; color: #000;">Jobs will continue to run with this window closed</div>                
                <button class="administrator-button button-cancel job-runner-viewer-button" @click="onClose" title="Close Job Viewer" aria-label="Close job viewer">
                    Close
                </button>
            </div>

            <div style="color:gray;background: white; overflow-y: auto;margin:auto; height: 90%;font-size:20pt;text-align: center;" v-show="dataReport == null">
                Loading...
            </div>

            <div style="background: white; overflow-y: auto;height: 90%;font-size:10pt" v-show="dataReport != null">
                <table class="report-div-table" cellspacing="0">
                    <tr class="report-div-table-row">
                        <th class="report-div-table-col-small" style="width:10%;">Job</th>
                        <th class="report-div-table-col-small" style="width:15%;">Started By</th>
                        <th class="report-div-table-col-small" style="width:15%;">Cancelled By</th>
                        <th class="report-div-table-col-small" style="width:15%;">Start</th>
                        <th class="report-div-table-col-small" style="width:15%;">End</th>
                        <th class="report-div-table-col-small" style="width:10%;">Status</th>
                        <th class="report-div-table-col-small" style="width:5%;text-align:right">Progress</th>
                        <th class="report-div-table-col-small" style="width:10%;">Action</th>
                        <th class="report-div-table-col-small" style="width:10%;">Logs</th>                        
                        <th class="report-div-table-col-small" style="width:10%;"></th>
                    </tr>

                    <tr v-for="row in dataReport" :key="row.description" class="report-div-table-row" style="height: 30px;">
                        
                        <td class="report-div-table-col-small">{{ row.displayName }}</td>
                        <td class="report-div-table-col-small">{{ row.startedBy }}</td>
                        <td class="report-div-table-col-small">{{ row.cancelledBy }}</td>
                        <td class="report-div-table-col-small">{{ row.startDisplay }}</td>
                        <td class="report-div-table-col-small">{{ row.endDisplay }}</td>
                        <td class="report-div-table-col-small">{{ row.statusDisplay }}</td>
                        <td class="report-div-table-col-small" style="text-align:right">{{ row.progress }}%</td>                                            
                        <td class="report-div-table-col-small">
                            <button v-if="row.jobAction == JobActionTypes.Download && row.jobStatus == JobStatusTypes.Completed" @click="onDownload(row)" style="text-align:left" class="button-link">Download</button>
                        </td>
                        <td class="report-div-table-col-small"><button @click="showLogs(row)" style="text-align:left" class="button-link">View</button></td>
                        <td class="report-div-table-col-small">
                            <button v-if="row.canCancel" @click="cancelJob(row)" style="text-align:left" class="button-link">Cancel</button>
                            <button v-if="row.canDelete" @click="deleteJob(row)" style="text-align:left" class="button-link">Delete</button>
                        </td>                        
                    </tr>
                </table>
            </div>
        </div>        
        <MessageBoxV3 v-show="messageBox_show" ref="refMessageBox" />
        <TextViewer v-show="textViewer_show" ref="refTextViewer" @close="textViewer_show = false"/>
    </div>
</template>

<script>
import apiJobRunner from "@/api/apiJobRunner";
import { ref } from "@vue/reactivity";
import { getCurrentInstance } from "@vue/runtime-core";
import Utilities from "@/common/utilities";
import PortalUserModel from "@/common/models/PortalUserModel";
import MessageBoxV3 from "@/views/components/Shared/MessageBoxV3";
import { JobActionTypes, JobStatusTypes } from "@/common/enums";
import TextViewer from "@/views/components/Shared/TextViewer";

export default {
    components: {  
        MessageBoxV3,
        TextViewer
    },
    setup(props, { emit }) {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(true);        
        const dataReport = ref();

        const messageBox_show = ref(false);
        const refMessageBox = ref(null);        
        const textViewer_show = ref(false);
        const refTextViewer = ref();
        
        var statusInterval = null;

        const onClose = () => {            
            window.clearInterval(statusInterval);
            dataReport.value = null;
            emit("on-close");
        };    
        
        const startPolling = async () => {
            console.log("startPolling!")
            textViewer_show.value = false
            messageBox_show.value = false
            statusInterval = window.setInterval(onView, 7000);
            await onView()
        }

        const onView = async () => {            
            try {                
                fetchingData.value = true;
                //emitter.emit("server-call-start", "Loading...");

                dataReport.value = await apiJobRunner.getAll();

                // Are there any running jobs                
                var anyRunning = dataReport.value.some((x) => x.isRunning);
                emitter.emit("set-jobs-running", anyRunning);
            } catch (err) {
                console.log("ERROR:", err);
                //emitter.emit("show-alert", ["Error loading data", err]);
            }
            //emitter.emit("server-call-stop");
            fetchingData.value = false;
        };
        

        var portalUser = PortalUserModel.fromToken();
   
        const onDownload = async (row) => {                        
            try {
                emitter.emit("server-call-start", "Processing downloading...");
                var urls = await apiJobRunner.getUrls(row.jobId);

                var fileText = "";
                for (let index = 0; index < urls.length; index++) {
                    const url = urls[index];

                    const response = await fetch(url);
                    const data = await response.text();                                
                    fileText = fileText + data;                                        
                }

                if (row.displayName == "Member Export") {                    
                    fileText = sortCsv(fileText, 0, true);
                    fileText = fileText.replaceAll("//n", "\n")
                }

                var element = document.createElement("a");
                element.setAttribute("href", "data:application/csv;charset=utf-8," + encodeURIComponent(fileText));
                // element.setAttribute("download", "member-export.csv");                
                element.setAttribute("download", `${row.displayName.replaceAll(' ', '-')}.${portalUser.tenant}.csv`);

                element.style.display = "none";
                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error processing deleting", err]);
            }
            emitter.emit("server-call-stop");            
        }

        const sortCsv = (csvData, columnIndex, asNumeric) =>
        {
            // Step 1: Parse CSV data into an array of rows
            const rows = csvData.split('\n')
                .map(row => row.split(','))
                .filter(row => row.some(cell => cell.trim() !== "")); // Exclude blank rows

            // Step 2: Sort rows by the first column (excluding the header)
            const header = rows.shift(); // Separate header row

            var collator = new Intl.Collator([], {numeric: asNumeric});
            rows.sort((a, b) => collator.compare(a[columnIndex], b[columnIndex]));            

            // Step 3: Combine the header with the sorted rows
            const sortedRows = [header, ...rows];

            // Convert the array back to CSV format if needed
            const sortedCsvData = sortedRows.map(row => row.join(',')).join('\n');

            return sortedCsvData;
        }

        const deleteJob = async (row) => {                        
            refMessageBox.value.showDialog(`Are you sure you want to delete job ${row.displayName}?`, "Delete Job", deleteItem.bind(this, row), () => {
            return (messageBox_show.value = false);
            });
            messageBox_show.value = true;    
        }

        const deleteItem = async (row) => {
            try {
                emitter.emit("server-call-start", "Processing deleting...");                
                await apiJobRunner.delete(row.jobId);

                await onView()
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error processing deleting", err]);
            }
            emitter.emit("server-call-stop");
            messageBox_show.value = false
        };   
        
        const cancelJob = async (row) => {                        
            refMessageBox.value.showDialog(`Are you sure you want to cancel job ${row.displayName}?`, "Cancel Job", cancelItem.bind(this, row), () => {
            return (messageBox_show.value = false);
            });
            messageBox_show.value = true;    
        }

        const cancelItem = async (row) => {
            try {
                emitter.emit("server-call-start", "Processing Cancel...");                
                await apiJobRunner.cancel(row.jobId);

                await onView()
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error processing cancel", err]);
            }
            emitter.emit("server-call-stop");
            messageBox_show.value = false
        };   

        const showLogs = async (row) => {                        
            try {
                emitter.emit("server-call-start", "Processing getting logs...");
                var logs = await apiJobRunner.getLogs(row.jobId);
                console.log(logs)

                refTextViewer.value.showDialog(logs, "Job Info")
                textViewer_show.value = true

            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error processing deleting", err]);
            }
            emitter.emit("server-call-stop");            
        }

        return {            
            dataReport,
            onClose,
            onView,
            Utilities,            
            portalUser,
            deleteJob,
            cancelJob,
            messageBox_show,
            refMessageBox,
            onDownload,
            JobActionTypes,
            JobStatusTypes,
            startPolling,
            showLogs,
            textViewer_show,
            refTextViewer
        };
    }
};
</script>

<style scoped>
.job-runner-viewer-modal {
    width: 80%;
    height: 60%;
    margin: 100px auto;
    background: white;
    border-radius: var(--button-border-radius);
}


.job-runner-viewer-button {
    /* background-color: cornflowerblue; */
    /* color: var(--button-color); */
    padding: 10px;
    margin: auto 10px;
    width: 75px;
    /* height: 30px;
    cursor: pointer;     */

}
</style>
